import React, {Fragment} from 'react'
import {connect} from 'react-redux'
import {browserHistory} from 'react-router'
import styles from './CreateEditCollection.scss'
import {errorMessage} from 'lib/styleguide/base.scss'
import {collectionsMessages} from 'features/homepage/Collections/intlMessages'
import {collectionActions} from 'data/resources/collections'
import {collectionItemActions} from 'data/resources/collectionItems'
import {Collection} from 'data/records'
import {ConfirmationDialog} from 'common/styleguide/ConfirmationDialog'
import {ImageUpload} from 'common/styleguide/ImageUpload'
import {Checkbox} from 'common/styleguide/Checkbox'
import plusIcon from 'assets/images/goals/plusIcon.svg'
import {Msg, commonNouns, commonVerbs} from 'lib/localization'
import {missingPhoto} from 'lib/photoUtils'
import {FormattedMessage as T} from 'react-intl'
import {Map} from 'immutable'

export const CREATE_EDIT_COLLECTION_DIALOG = 'CREATE_EDIT_COLLECTION_DIALOG'

const reduceBlobURL = image => (
  !image || typeof image === 'string'
    ? image
    : image.preview
)

export class _CreateEditCollection extends React.PureComponent {
  constructor (props) {
    super(props)
    const {collection} = props

    this.state = {
      collection: collection || Collection({title: '', description: ''}),
      pendingEdits: Map(),
      savePending: false,
      error: {}
    }
  }

  setPendingEdit (key, value) {
    const {pendingEdits} = this.state
    this.setState({pendingEdits: pendingEdits.merge({[key]: value})})
  }

  onTitleChange = (e) => {
    this.setPendingEdit('title', e.target.value)
  }

  onDescriptionChange = (e) => {
    this.setPendingEdit('description', e.target.value)
  }

  onCoverDrop = (files) => {
    if (files && files[0]) {
      this.setPendingEdit('cover', files[0])
    }
  }

  onShowMapChange = (e) => {
    this.setPendingEdit('showMap', e.currentTarget.checked)
  }

  onSubmit = (e) => {
    e.preventDefault()
    this.setState({savePending: true})
    const {
      createCollection,
      updateCollection,
      createCollectionItem,
      onRequestClose,
      itemsToAdd,
      itemType
    } = this.props
    const {collection, pendingEdits} = this.state
    let nextCollection = collection.merge(pendingEdits)
    if (!nextCollection.title || nextCollection.title === '') {
      this.setState({savePending: false, error: {title: <Msg m={collectionsMessages.noTitleError} />}})
      return
    } else if (nextCollection.title.length > 80) {
      this.setState({savePending: false, error: {title: <Msg m={collectionsMessages.tooLongError} />}})
      return
    }

    const actionCreator = collection && collection.id
      ? updateCollection
      : createCollection
    actionCreator(nextCollection)
      .then(response => {
        const {id} = response.value.collection
        this.setState({
          pendingEdits: Map(),
          savePending: false
        })

        itemsToAdd && itemsToAdd.forEach(i => {
          createCollectionItem({collectionId: id, itemId: i.id, itemType})
        })

        browserHistory.push(`/collections/${id}`)
        onRequestClose()
      })
      .catch(r => {
        this.setState({error: {server: e.errors[0].error_info}, savePending: false})
      })
  }

  render () {
    const {
      onRequestClose,
      modalTitle,
      titleOnly
    } = this.props
    const {
      collection,
      pendingEdits,
      savePending,
      error
    } = this.state
    const values = collection && collection.merge(pendingEdits)

    return (
      <ConfirmationDialog
        maxWidth='600px'
        onRequestClose={onRequestClose}
        onConfirm={e => this.onSubmit(e)}
        onCancel={onRequestClose}
        confirmText={<Msg capitalized m={commonVerbs.save} />}
        confirmPending={savePending}
        title={modalTitle}>
        <form onSubmit={e => this.onSubmit(e)}>
          <div>
            <label htmlFor='title-input'><Msg capitalized m={commonNouns.title} /></label>
            <input id='title-input'
              type='text'
              value={values.title}
              onChange={this.onTitleChange} />
            {error.title && <div className={errorMessage}>{error.title}</div>}
          </div>
          {!titleOnly && <Fragment>
            <div>
              <label htmlFor='description-input'><Msg capitalized m={commonNouns.overview} /></label>
              <textarea id='description-input'
                rows='2'
                value={values.description}
                onChange={this.onDescriptionChange} />
            </div>
            <div>
              <label><Msg capitalized m={commonNouns.image} /></label>
              <ImageUpload
                className={styles.imageUploadWithNote}
                onDrop={this.onCoverDrop}
                hintTop={<T
                  id='collectionModal.dropPhoto'
                  defaultMessage='Drop a photo for your cover here'
                  description='Placeholder text for an image uploader' />}>
                {values.cover && !missingPhoto(values.cover)
                  ? <img className={styles.plusIcon} height='80' width='80' src={reduceBlobURL(values.cover)} />
                  : <img className={styles.plusIcon} height='80' width='80' src={plusIcon} />}
              </ImageUpload>
            </div>
            {/* show this checkbox only on edit, not create */}
            {values.showMap !== null && <div>
              <Checkbox id='showMap-input'
                type='checkbox'
                checked={values.showMap}
                label={<T
                  id='collectionModal.showMap'
                  defaultMessage='Show map'
                  description='A toggle to show a map' />}
                onChange={this.onShowMapChange} />
            </div>}
          </Fragment>}
        </form>
      </ConfirmationDialog>
    )
  }
}

const mapDispatchToProps = {
  createCollection: collectionActions.create,
  updateCollection: collectionActions.update,
  createCollectionItem: (attrs) => collectionItemActions.create({collectionItem: attrs})
}

export const CreateEditCollection = connect(
  null,
  mapDispatchToProps
)(_CreateEditCollection)
